import { render, staticRenderFns } from "./ListaPlanos.vue?vue&type=template&id=2fcc08e7&scoped=true&"
import script from "./ListaPlanos.vue?vue&type=script&lang=js&"
export * from "./ListaPlanos.vue?vue&type=script&lang=js&"
import style0 from "./ListaPlanos.vue?vue&type=style&index=0&id=2fcc08e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc08e7",
  null
  
)

export default component.exports